<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>金币体力不足弹窗配置</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="金币不足" name="coins">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData" :key="index">
                <el-form-item label="ID">
                  <el-input v-model.number="item.gid" readonly style="width: 100px;" placeholder="ID" />
                </el-form-item>
                <el-form-item label="等级">
                  <el-input v-model.number="item.level" style="width: 100px;" placeholder="等级" />
                </el-form-item>
                <el-form-item label="vip点数">
                  <el-input v-model.number="item.point" style="width: 100px;" placeholder="vip点数" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:shopNotEnough:del']" type="danger" @click="del(item.gid, index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:shopNotEnough:add']" type="primary" @click="add()">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:shopNotEnough:add']" type="primary" @click="onSubmit()">保存</el-button>
            </el-form>

            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables"
            />
          </el-tab-pane>
          <el-tab-pane label="体力不足" name="spins">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData" :key="index">
                <el-form-item label="ID">
                  <el-input v-model.number="item.gid" readonly style="width: 100px;" placeholder="ID" />
                </el-form-item>
                <el-form-item label="等级">
                  <el-input v-model.number="item.level" readonly style="width: 100px;" placeholder="等级" />
                </el-form-item>
                <el-form-item label="vip点数">
                  <el-input v-model.number="item.point" style="width: 100px;" placeholder="vip点数" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:shopNotEnough:del']" type="danger" @click="del(item.gid, index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:shopNotEnough:add']" type="primary" @click="add()">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:shopNotEnough:add']" type="primary" @click="onSubmit()">保存</el-button>
            </el-form>

            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delCoinPopList, getCoinPopList, updateCoinPopCfg } from '@/api/config/coin-pop-cfg'

export default {
  name: 'RewardShopPromotionEdit',
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: 'money'
      },
      activeName: 'coins',
      formData: [{
        'gid': 0,
        'level': 0,
        'type': '',
        'point': 0
      }]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      const _data = JSON.stringify(this.formData)
      console.log(_data)
      updateCoinPopCfg({ data: _data, name: this.aid }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      if (this.activeName === 'coins') {
        this.queryParams.type = 'money'
      } else {
        this.queryParams.type = 'spins'
      }
      getCoinPopList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      if (this.activeName === 'coins') {
        this.formData.push({
          'gid': 0,
          'level': 0,
          'type': 'money',
          'point': 0
        })
      } else {
        this.formData.push({
          'gid': 0,
          'level': 0,
          'type': 'spins',
          'point': 0
        })
      }
    },
    del(id, i) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCoinPopList({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData = this.formData.filter((item, index) => {
          return index !== i
        })
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getTables()
    }
  }
}
</script>

<style scoped>
</style>
